import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalComponent } from '../../components/modal/modal.component';
import { LoginService } from 'src/app/user/services/login.service';
import { ActivatedRoute } from '@angular/router';
import { LookupService } from '../../services/lookup.service';
import { NotificationType } from '../../models/ui-notification.model';
import { UINotificationService } from '../../services/ui-notification.service';
import { EntityListRefresh } from '../../services/entity-list.refresh';

@Component({
  selector: 'app-create-basic-lookup',
  templateUrl: './create-basic-lookup.component.html',
  styleUrls: ['./create-basic-lookup.component.css']
})
export class CreateBasicLookupComponent implements OnInit {
  form = new FormGroup({});
  lookupType: string;
  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private uiNotificationService: UINotificationService,
    private entityListRefresh: EntityListRefresh
  ) { }

  ngOnInit() {
    this.lookupType = this.route.snapshot.paramMap.get('type');

    this.form.addControl('code', new FormControl('', Validators.required));
    this.form.addControl('lang', new FormControl(this.langs[0], Validators.required));
    this.form.addControl('title', new FormControl('', Validators.required));
    this.form.addControl('description', new FormControl('', Validators.required));

    this.form.controls['lang'].disable();
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid && this.loginService.isSuperadmin()) {
      const lookupLang = [
        { twoLetterISOLanguageName: 'cs', title: this.form.get('title').value, description: this.form.get('description').value},
        { twoLetterISOLanguageName: 'de', title: this.form.get('title').value, description: this.form.get('description').value },
        { twoLetterISOLanguageName: 'en', title: this.form.get('title').value, description: this.form.get('description').value }
      ];

      this.lookupService.create({
        code: this.form.get('code').value,
        language: lookupLang
      }, this.lookupType).subscribe(() => {
        this.entityListRefresh.refresh('lookup');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Položka byla přidána'
        });
        modal.closeModal(null);
      });
    }
    
  }

}
